import { gray5, mainColor, mainSub1Color, white } from "assets/styleUtils";
import { CertifyPhone } from "components/CertifyPhone";
import { IUser } from "data/user";
import _ from "lodash";
import { sendAuthCode } from "pages/CounselingInfo/CounselingInfo";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "recoil/atoms";
import { fetcher, post } from "utils/ApiUtil";
import styles from "./style.module.css";

export default function MyProfilePage() {
  const user = useRecoilValue(userState);
  const setUser = useSetRecoilState(userState);
  const navigation = useNavigate();

  const [isError, setIsError] = useState(false);
  const [change, setChange] = useState(false);
  const [currentUser, setCurrentUser] = useState<IUser>();
  const [revisedUser, setRevisedUser] = useState<IUser>();
  const [userPhoneNum, setUserPhoneNum] = useState(
    revisedUser?.phone_number || "",
  );
  const [authCode, setAuthCode] = useState<string>();
  const [photo, setPhoto] = useState(revisedUser?.profile_img || "");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const codeNumberRef = useRef(null);
  const nicknameRef = useRef(null);
  const phoneNumberRef = useRef(null);

  const [existPhoneNum, setExistPhoneNum] = useState(
    userPhoneNum?.length === 11 || false,
  );

  const isAuthCode = typeof authCode === "string";

  const changeUserPhoneNumber = (text: string) => {
    if (text === user?.phone_number) {
      setExistPhoneNum(true);
    } else {
      setExistPhoneNum(false);
    }
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onUploadImage = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        setFile(e.target.files[0]);
      }
    },
    [],
  );

  async function updateProfile() {
    if (
      currentUser &&
      revisedUser &&
      currentUser?.nickname !== revisedUser?.nickname
    ) {
      try {
        const { nickname } = revisedUser;
        const { message, success } = await post("/api/user/nicknamecheck", {
          nickname,
        });
        if (!success) {
          return toast(message);
        }
      } catch (error: any) {
        return toast(
          error?.message || "에러가 발생했습니다. 관리자에게 문의해주세요",
        );
      }
    }
    if (
      currentUser &&
      revisedUser &&
      currentUser.phone_number !== userPhoneNum
    ) {
      if (!existPhoneNum) {
        return toast.error("휴대폰 번호를 인증해주세요.");
      }
    }
    const result = await fetcher("/api/user/updatesignup", revisedUser);

    if (result.success) {
      toast.success(result.message);
      setCurrentUser(revisedUser);
      setRevisedUser(revisedUser);
      setUser(revisedUser);
      setAuthCode(undefined);
      setChange(false);
      if (result.success) {
        navigation(-1);
      }
    }
  }

  const uploadImage = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("files", file);
      try {
        const response = await post("/api/utils/communityimgs", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data.imglist;
      } catch (error) {
        toast.error("업로드 오류가 발생했습니다");
        return null;
      }
    }
    return null;
  };

  useEffect(() => {
    if (file) {
      uploadImage().then((imgList) => {
        if (imgList !== null && revisedUser) {
          // setPhoto(imgList);
          setRevisedUser({
            ...revisedUser,
            profile_img: imgList,
          });
        }
      });
    }
  }, [file]);

  useEffect(() => {
    if (currentUser?.phone_number !== userPhoneNum) {
      setAuthCode(undefined);
    }
  }, [userPhoneNum]);

  useEffect(() => {
    if (existPhoneNum && revisedUser) {
      setRevisedUser({
        ...revisedUser,
        phone_number: userPhoneNum,
      });
    }
  }, [existPhoneNum]);
  useEffect(() => {
    const prevUserPhoneNum = userPhoneNum;
    const prevPhoto = photo;

    if (
      prevUserPhoneNum !== revisedUser?.phone_number ||
      prevPhoto !== (revisedUser?.profile_img || "") ||
      !_.isEqual(currentUser, revisedUser)
    ) {
      setChange(true);
    } else {
      setChange(false);
    }
  }, [revisedUser, userPhoneNum, photo]);

  useEffect(() => {
    setCurrentUser(user);
    setRevisedUser(user);
  }, []);

  useEffect(() => {
    if (revisedUser) {
      setExistPhoneNum(revisedUser.phone_number ? true : false);
      setUserPhoneNum(revisedUser.phone_number || "");
      setPhoto(revisedUser.profile_img || "");
    } else {
      setExistPhoneNum(false);
      setUserPhoneNum("");
      setPhoto("");
    }
  }, [revisedUser]);

  return (
    <div style={{ backgroundColor: "#FFFFFF" }}>
      <div style={{ padding: "0 45px 0 45px" }}>
        <div style={{ alignItems: "center", marginTop: "40px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{ width: "90px", height: "90px", position: "relative" }}
            >
              <img
                className={styles.myProfileImage}
                src={
                  !isError && revisedUser && photo
                    ? photo
                    : "/images/defaultImg.png"
                }
                alt="Profile"
              />
              <div className={styles.myProfileImageButton}>
                <img
                  src="/images/camera.png"
                  style={{
                    width: "15px",
                    height: "15px",
                    cursor: "pointer",
                  }}
                  alt="Camera"
                  onClick={handleClick}
                />
                <input
                  ref={fileInputRef}
                  type="file"
                  name="image"
                  accept=".jpg, .png, .jpeg, .gif, image/jpg, image/png, image/jpeg, image/gif"
                  onChange={onUploadImage}
                  multiple
                  style={{ display: "none", direction: "rtl" }}
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: "16px" }}>
            <div className={styles.container}>
              <div>닉네임</div>
              <input
                ref={nicknameRef}
                placeholder="닉네임"
                value={revisedUser && revisedUser.nickname}
                onChange={(e) => {
                  if (revisedUser) {
                    setRevisedUser({
                      ...revisedUser,
                      nickname: e.target.value,
                    });
                  }
                }}
              />
            </div>
            <div className={styles.container}>
              <div>이름</div>
              <input
                placeholder="이름"
                value={revisedUser && revisedUser.name}
                onChange={(e) => {
                  if (revisedUser) {
                    setRevisedUser({ ...revisedUser, name: e.target.value });
                  }
                }}
              />
            </div>
            <div className={styles.container}>
              <div>성별</div>
              <div style={{ display: "flex", width: "100%" }}>
                <div
                  onClick={() => {
                    if (revisedUser) {
                      setRevisedUser({ ...revisedUser, gender: "남자" });
                    }
                  }}
                  style={{
                    backgroundColor:
                      revisedUser && revisedUser.gender === "남자"
                        ? mainSub1Color
                        : undefined,
                    color:
                      revisedUser && revisedUser.gender === "남자"
                        ? white
                        : undefined,
                  }}
                  className={styles.gender}
                >
                  남자
                </div>
                <div
                  onClick={() => {
                    if (revisedUser) {
                      setRevisedUser({ ...revisedUser, gender: "여자" });
                    }
                  }}
                  style={{
                    backgroundColor:
                      revisedUser && revisedUser.gender === "여자"
                        ? mainSub1Color
                        : undefined,
                    color:
                      revisedUser && revisedUser.gender === "여자"
                        ? white
                        : undefined,
                  }}
                  className={styles.gender}
                >
                  여자
                </div>
              </div>
            </div>
            <div className={styles.container}>
              <div>휴대폰 번호</div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <input
                  ref={phoneNumberRef}
                  maxLength={11}
                  type="number"
                  placeholder="휴대폰 번호"
                  value={userPhoneNum}
                  // onChange={(e) => {
                  //   if (revisedUser) {
                  //     setRevisedUser({
                  //       ...revisedUser,
                  //       phone_number: e.target.value,
                  //     });
                  //   }
                  // }}
                  onChange={(e) => {
                    const input = e.target;
                    const maxLength = 11;

                    if (input.value.length > maxLength) {
                      input.value = input.value.slice(0, maxLength);
                    }
                    setUserPhoneNum(e.target.value);
                    changeUserPhoneNumber(input.value);
                  }}
                  style={{ width: "80%" }}
                />
                <div
                  style={{
                    width: "50px",
                    height: "40px",
                    marginTop: "10px",
                    textAlign: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    color: existPhoneNum ? "green" : "red",
                  }}
                  onClick={() => {
                    if (!existPhoneNum) {
                      if (userPhoneNum?.length === 11) {
                        sendAuthCode({
                          setCodeCallback: setAuthCode,
                          bride_phone: userPhoneNum,
                        });
                      } else {
                        toast.error("휴대폰 번호를 확인해주세요");
                      }
                    }
                  }}
                >
                  {existPhoneNum ? "인증됨" : "인증하기"}
                </div>
              </div>
              {isAuthCode && (
                <CertifyPhone
                  bride_phone={userPhoneNum}
                  code={authCode}
                  setExistPhoneNum={setExistPhoneNum}
                  setAuthCode={setAuthCode}
                  width="80%"
                />
              )}
            </div>
          </div>
          <div
            onClick={() => {
              change && updateProfile();
            }}
            style={{
              backgroundColor: change ? mainColor : gray5,
              padding: "10px",
              margin: "0 10px 0 10px",
              borderRadius: "4px",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <div style={{ color: white }}>변경하기</div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </div>
  );
}
